// Default home page content — matches the original Index.jsx
// All values can be overridden by tenant's page.content JSON

const IMG = {
    cyberpunk: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD6L4qfXzcxpYbZTIZosVLDp7MrKXN66hmGVJqmJcdoMLHK4pRO6V3fQnAVtthIK2gQ2ZsSTrkfrSdZI51WINZMb_asHbVI22no-XOKyfixW3cRmm_vGFvXTpuoYd3hjxF80jBdEKqbJpOlH4BjquL1n0eulJUYsn4Risb7T_ka-FlZe2DsxbOJtJZP9mJbMxrgUOkmW3IldBtwH90e33jaArK1h8lm7p33rY6aPsWFgAH2BJb7bghQMntCyDnvJVn1DG14UdgDQA',
    abstract: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCXpwF9kWBTEmYfgTuH3VsNdy86QxSmyxuTTsTc-LE14edhwxOwsX2xidizMxhD3ndZZ_L-6scJbH50iIv30_q1YiqXSZrZHL5b3JN_AcSDh7vapYDVU_0L2QbcFzrWSfHxESF7x-s1Hfy2IYhgQcyaoXjypzAx9tCAyX_WtqmazVy6WSkke9z1ReABr4ZRvWPCD3OIVS5deZdbtv3X_Rca1xFca_lbOaqXcr3cS4UaO3ZqLQmDKhaKHc7P6dYPdWJmTn5tnqEWTw',
    character: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDx9qFs91BEjHWXEnlkG9uflKwYK972nCfuF85rS-Ffxn2JwP8w9liOG3eLR1Rw4Qwa_SSVW5ehkTZ8J_1lvXq2kotTKyVOwg9hH0Dxhwbuc56cym5IMsTl9mwjcEEe41MW-KiXWQnF2YqH2Kr7dNrwtW9QOrZ9HSgrDA8QxS84gU3VKlzylkB_Sw957fSko5I0IK0QuLTnr-qKWQe64SaBZSuoQYgRfF1giycTsRTfRWLYGP5XqW13WKYugTpRjxXnceU9lTbm7Q',
    landscape: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD4yZcKLEXnPQUU7K8kRmwTxOP0SvxVPh5TGeYi_SaNNLEWH_hUa-D5U45Jea-Re_Q-DtJWFystqesNfTJT26oVlY3yets1uUBnh4BrEXtN-JpenhMljxwzuMbZ83-84QXa0zv4e41Bbb8sp8TWn8j0RgulN02-5GF3Rx4R64nV1HFFMO86h5PNmufNkbdzq0yaj6CfvM3odB_l4Dt3fL8bbzPKnjD_7bcX9vCScVeRoJkY6X00uoaxBs5_3wbbF9dio9lAl_ISHg',
    portrait: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDnz9KCWLwE8jXW9IPokXis4BIkaE8eCRAyBQHVUA5QtKXwbIXkHev9vKWx1gPbhjMsBCxrEFD42d5plCA2Nrdf91_NHtNnS-p9ayHzYMzUa5mDKSGtwyjB0QyEgGs2A1I8mfgXsckjf4m1sYddwphPQ5IpSJ7rxehPJpxRPgLhgWh8Faz8m2Tm2pu4iZVm_fKFBxE9-a2YSWlsAwtWPmHltTl4IyAhCIp2D8TbQzYGHFMsuEaEr8WoxZA5d48XxO6xljHFMkxuIQ',
    scifi: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAcyUw6IcePaTslBnbq58dm6C7nQ0J0KWQtycAi8QGxWoObrScJTb0HCqw3cQG21pZKXIu0vOQWHtNfc1Y5AKgSzzrlE9k3xADAfe-5oWoP3JMU8V1R_wLJPjE1sdVVRg_ipJzCBX8lJedZxu8UQ2ZvjFXBiZiqvbuD6XGooiQHp0ElPp8UbEDhxKE4WtkvRDlTZyLHkdo3Ebb221VrROd-6Heog9CSYmWcG3YGcj4wVLZkBSKMD9S_Ir5lL9PdPfkqi54x-4WVEw',
    vthumb1: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDJrMcj5dpG9iRwwib68N2g1EDv7ZNRWbGJOWi5lrYdVhJU8fBiBaqjmPRqmSXLqNvQNeouB71dpZ6PTXMZPFrqQAP5iRTtC0YeNRFbNjl_w4iaRhIpPTr_r1XMuk75juGlMeU2gX4ECUFNwYM06zFVxhbxd_hUp68anFK_ufdjpTJfIPraGqfQ-1VoHXLGU5abDNnx_xAnzw7XOcKxcdrF6hoD0gIKiMj87zHaGOIR5q2FfNgoNZvveY-9gxpOeqanrnAkHi0HNQ',
    vthumb2: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCfK89n9f-ivmU7-k61gys9dBrF1y5v8HkR1BDw0wsL-8a_ZTpiptBrqxP40hstBaxxPH5VL7fONuYN4Bprfl8onNXdPC9aBgOllDBYM0pGjbUMBVVIpBqjWyZIBXvMJBkAGh4kyz0WfVsoGXzE3BNUF5YTxAFevoVxtZtjPLGBvXwKLmOORa3WSfDAnVB6l4iGC3Dl5Qku3NmN6AJES4q7TGjM1yjwlPgh8po_vgx3rl6OtcqCDyCIcGylY3k5LpN9hAiS3E4eVw',
    vthumb3: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD_7BHuyXTzNgtJ7gg9mtHCOY58xOrV8QgNk-qLcn_bvbgKwOpqmOE8f1wY6wpZ_hOdwqaiYpEf_DDxGEknnca8V59ufdMyD5hSbwS9IJccLAPRpM6wUQULYqwacuJDy-5Mn7dwa_S8Cw5f6buqMQtSLxfMN1L38PixOcZzYZPVwYkA6WRb3XBWx3aKQmAs1M-c380UP9WyWHf7y_qH5otk8uxhgQAkl6RDFKSmiJZaGmuX_1buLkCi1ENQn3aoUgRXHlxhriLYTg',
    vthumb4: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCNmKUuU5Z2iRco8Sq_3C8GZLBkkXAauXUWrXnu7LyNQOZPbznMv3JDfXlTwd-hQ--ZSKe4YjDuhRNJos0U7fpDDjjcP6hdcfcWP6PQ0P4HYdBzVlbiLsVAg4L9v60npcVr0wNqxMCZX7Br1qdAwYJEEVEJIjDyFR4AkYaZ4vK0QWs92Azic_v7BUo1agApH8O0h_qFVx8d0ubqiEcBdDEYwXeYkApunNNZaEynSnNfQiERGSx9nAXNJvlzlmXuBxZfM6-VbfJjog',
    vthumb5: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBCEE7cHGgRL4Nakrg9nPuMLOw63kNIjiE3-HsrrKHRNmXPbSiy1o5vsqzdGGZvk8OtOhTKSs3P_OQy8glImA6eCmrCxCT6sQJF2HG8-CF32vxxDvd0LMlEUkENIlunkiNYh4jjEZoGCqNThRuPM_quQ11UikHeyphfKlay6Z39j1PLYCp9baK9pfqTbeLh_mizm4yTunSRWLxJO7nk0siwfhJYE8xaFXSxLZ11U0HZuDKVwI0wbesL3_JoKmqZLsn3wd4UE37C8A',
    vthumb6: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDtBxPdRv4t-reKTEh-QKz0Xz0yAgjgpc3c9J7SR9VDgLkRCBJisdI042cDmYEeUZd8eTOuivAn6vrVo-Sg2LzXnyveSzybmMGMlTWVOcIYigAcuBBJMG2lnMzDd-XH-UTS0PYlbDb1ohXw4x4-o5eRLi0Iad5WgF14jGbkh11xYPO9E8PMY5xHRyqh8o3jjGHSmEJZrqCDo2JmWaPX2PLr2VeSHzQZ8pwuKtrnC8f52fBHXLHoBFjTl3QnOnP79BIFAHHUMyyZGg',
};

const VID_CONTENT = '/storage/tenants/hsyv5kcc/general/content-video-section.mp4';
const VID_BANNER = '/storage/tenants/hsyv5kcc/general/Banner-background.mp4';

const DEFAULTS = {
    // Hero
    hero_bg: '',
    hero_small_title: 'AI-Powered Platform',
    hero_main_title: 'Redefine <span class="text-primary">Creativity</span> with AI',
    hero_description: `${import.meta.env.VITE_MASTER_TENANT_NAME} is an integrated ecosystem for creative intelligence. Generate cinematic visuals, custom AI agents, and professional-grade audio in seconds.`,
    hero_btn_1_text: 'Get Started Free',
    hero_btn_1_url: '',
    hero_btn_2_text: 'View Pricing',
    hero_btn_2_url: '/pricing',

    // Stats
    stat_number_1: '10M+', stat_label_1: 'Images Generated',
    stat_number_2: '500K+', stat_label_2: 'Active Creators',
    stat_number_3: '2M+', stat_label_3: 'Videos Created',
    stat_number_4: '99.9%', stat_label_4: 'Uptime',

    // Intro
    intro_badge: 'AI-Powered Platform',
    intro_title: 'Experience the <br /><span class="text-primary">Next Era</span> of Design',
    intro_desc: `${import.meta.env.VITE_MASTER_TENANT_NAME} is an integrated ecosystem for <span class="text-primary font-bold">creative intelligence</span>. We provide cutting-edge models for generating <span class="text-primary font-bold">cinematic visuals</span>, custom AI agents, and professional-grade audio.`,
    intro_check_1: 'No Credit Card Required',
    intro_check_2: 'Start in 30 Seconds',
    intro_video: VID_CONTENT,

    // Image Studio
    image_studio_badge: 'Image Studio',
    image_studio_title: 'AI-Powered <span class="text-primary">Image Creation</span>',
    image_studio_desc: 'Transform your imagination into high-fidelity visuals with our state-of-the-art diffusion models.',
    image_cards: [
        { title: 'Cyberpunk', main: IMG.cyberpunk, sub1: IMG.abstract, sub2: IMG.character },
        { title: 'Abstract', main: IMG.abstract, sub1: IMG.cyberpunk, sub2: IMG.landscape },
        { title: 'Character', main: IMG.character, sub1: IMG.portrait, sub2: IMG.scifi },
        { title: 'Landscape', main: IMG.landscape, sub1: IMG.cyberpunk, sub2: IMG.abstract },
        { title: 'Portrait', main: IMG.portrait, sub1: IMG.character, sub2: IMG.scifi },
        { title: 'Sci-Fi', main: IMG.scifi, sub1: IMG.portrait, sub2: IMG.landscape },
    ],

    // Video Trends
    video_trends_badge: 'Video Trends',
    video_trends_title: 'Trending <span class="text-primary">Avatar Templates</span>',
    video_trends_desc: 'Preview popular avatar video templates before creating your own.',
    show_video_trends: true,

    // Quick Actions
    quick_actions_badge: 'AI Models',
    quick_actions_title: 'Explore AI Capability',
    quick_actions_desc: 'Access all premium generation models and tools instantly from your dashboard.',
    show_quick_actions: true,
    quick_actions: [
        { label: 'Veo 3.1', url: '/generations/veo-31', image: IMG.landscape },
        { label: 'Kling 3.0', url: '/generations/kling-30', image: IMG.cyberpunk },
        { label: 'Sora 2', url: '/generations/sora2', image: IMG.scifi },
        { label: 'WAN 2.2 Animate', url: '/generations/wan-22-animate', image: IMG.abstract },
        { label: 'SeeDance 1.5', url: '/generations/seedance15', image: IMG.portrait },
        { label: 'SeeDance 2.0', url: '/generations/seedance-2', image: IMG.portrait },
    ],

    // Video Studio
    video_studio_badge: 'Video Studio',
    video_studio_title: 'AI-Powered <span class="text-primary">Video Creation</span>',
    video_studio_desc: 'Generate cinematic sequences and stunning motion graphics using simple text prompts.',
    video_cards: [
        { title: 'Cinematic', thumbnail: IMG.vthumb1, video: VID_CONTENT, sub1: IMG.abstract, sub2: IMG.character },
        { title: 'Commercial', thumbnail: IMG.vthumb2, video: VID_BANNER, sub1: IMG.cyberpunk, sub2: IMG.landscape },
        { title: 'Animation', thumbnail: IMG.vthumb3, video: VID_CONTENT, sub1: IMG.portrait, sub2: IMG.scifi },
        { title: 'Documentary', thumbnail: IMG.vthumb4, video: VID_BANNER, sub1: IMG.cyberpunk, sub2: IMG.abstract },
        { title: 'Music Video', thumbnail: IMG.vthumb5, video: VID_CONTENT, sub1: IMG.portrait, sub2: IMG.scifi },
        { title: 'Social Media', thumbnail: IMG.vthumb6, video: VID_BANNER, sub1: IMG.portrait, sub2: IMG.landscape },
    ],

    // Chat
    chat_badge: 'Chat Studio',
    chat_title: 'AI <span class="text-primary">Conversations</span> That Feel Human',
    chat_desc: 'Build custom AI personas with unique personalities, knowledge bases, and conversation styles. Perfect for customer service, creative brainstorming, or just having fun.',
    chat_features: [
        'Multi-language support with 50+ languages',
        'Custom personality & tone configuration',
        'Long-term memory across conversations',
        'Voice input & output capabilities',
    ],

    // Voice
    voice_badge: 'Voice Studio',
    voice_title: '<span class="text-primary">Neural Voice</span> Synthesis',
    voice_desc: 'Create ultra-realistic voiceovers with advanced AI. Clone voices, generate podcasts, audiobooks, and more with studio-quality output.',
    voice_features: [
        'Natural-sounding speech in 100+ languages',
        'Custom voice cloning from samples',
        'Emotion & tone control',
        'Commercial license included',
    ],

    // CTA
    cta_title: 'Ready to',
    cta_subtitle: 'Create',
    cta_desc: `Join thousands of creators using ${import.meta.env.VITE_MASTER_TENANT_NAME} to bring their imagination to life.`,
    cta_btn_primary: 'Get Started Free',
    cta_btn_secondary: 'View Pricing',
    cta_tagline: 'No credit card required · 100 free credits to start',

    // Section visibility
    show_intro: true,
    show_images: true,
    show_videos: true,
    show_chat: true,
    show_voice: true,

    // Custom CSS
    custom_css: '',
};

/**
 * Merge tenant page.content with defaults.
 * Returns the complete content object ready to use in theme components.
 */
export function useHomeContent(pageContent = {}) {
    const merged = { ...DEFAULTS };
    Object.keys(pageContent || {}).forEach(key => {
        if (pageContent[key] !== null && pageContent[key] !== undefined && pageContent[key] !== '') {
            merged[key] = pageContent[key] === '/dashboard' ? '/manager/dashboard' : pageContent[key];
        }
    });
    return merged;
}

export { DEFAULTS, IMG, VID_CONTENT, VID_BANNER };
